var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.namespaceClass('bodyer')},[_c('Workbook')],1)}
var staticRenderFns = []

export { render, staticRenderFns }